<template>
  <header>
    <div
      class="t-modal-header shadow bg-white fixed inset-x-0 top-0 w-full z-50 box-border border-t-0 border-l-0 border-r-0 border-b border-gray-300 border-solid"
    >
      <div class="px-4 py-5 sm:px-6 h-16">
        <slot></slot>

        <div class="block absolute top-0 right-0 pt-2 pr-2">
          <UButton
            color="white"
            variant="ghost"
            size="xl"
            icon="i-heroicons-x-mark"
            :aria-label="$t('a11y.close')"
            @click="$emit('close')"
          />
        </div>
      </div>
    </div>

    <div class="h-16 z-0 relative" />
  </header>
</template>

<script setup lang="ts">
defineEmits(['close'])
</script>
